module.exports = __webpack_public_path__ + "static/flags/GH-dfedc1e89eecff3d29a7beea40f409f2.gif";